/* eslint-disable no-console */
import * as integration from '../../../integration'
import * as types from './types'

export const fetchFilters = (value = true) => ({
  type: types.FETCH_FILTERS,
  payload: value
})

export const receiveFilters = (name, data) => ({
  type: types.RECEIVE_FILTERS,
  payload: {
    name,
    data
  }
})

export const getFilters = (name, request) => async (dispatch) => {
  dispatch(fetchFilters())

  try {
    const res = await request()

    dispatch(receiveFilters(name, res.data))

    return res
  } catch (err) {
    dispatch(fetchFilters(false))

    return Promise.reject(err)
  }
}

export const getStoreStatuses = () =>
  getFilters(
    'storeStatuses',
    integration.resources.filters.requests.getStoreStatuses
  )

export const getStoreGroups = () =>
  getFilters(
    'storeGroups',
    integration.resources.filters.requests.getStoreGroups
  )

export const getStoreProducts = () =>
  getFilters(
    'products',
    integration.resources.filters.requests.getStoreProducts
  )

export const getNetworks = () =>
  getFilters('networkCodes', integration.resources.filters.requests.getNetworks)

export const getSubsidiary = () =>
  getFilters(
    'subsidiaryCodes',
    integration.resources.filters.requests.getSubsidiary
  )

export const getPartners = () =>
  getFilters(
    'partnerStdCodes',
    integration.resources.filters.requests.getPartners
  )

export const getPriorityMatrices = () =>
  getFilters(
    'priorityMatrices',
    integration.resources.filters.requests.getPriorityMatrices
  )

export const getSegments = () =>
  getFilters('segments', integration.resources.filters.requests.getSegments)

export const getSubSegments = () =>
  getFilters(
    'subsegments',
    integration.resources.filters.requests.getSubSegments
  )
